// Help center routes, kept apart from the article content so client
// components can use them without bundling every article.
export const HELP_CENTER_PATH = "/help-center";
export const KB_BASE_PATH = `${HELP_CENTER_PATH}/knowledge-base`;
